var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dataArrayChunk, REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
import { failureHash } from "./pageconfigaccount.static";
export const ApiEpPageconfigaccount = {
    list: (req) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (((_a = req === null || req === void 0 ? void 0 : req.query) === null || _a === void 0 ? void 0 : _a.page_config__in) && req.query.page_config__in.length > 100) {
            let results = [];
            const chunks = dataArrayChunk(req.query.page_config__in, 100);
            for (let chunk of chunks) {
                const resultChunk = yield apiRequest({
                    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfigaccount`,
                    method: "GET",
                    query: Object.assign(Object.assign({}, req.query), { page_config__in: chunk }),
                }, failureHash);
                results = [...resultChunk, ...results];
            }
            return results;
        }
        else {
            return apiRequest({
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfigaccount`,
                method: "GET",
                query: req === null || req === void 0 ? void 0 : req.query,
            }, failureHash);
        }
    }),
    retrieveByPageconfigId: ({ id }) => apiRequest({
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfigaccount?page_config=${id}`,
        method: "GET",
    }, failureHash),
    updatePartial: ({ pageConfigAccount, }) => apiRequest({
        body: pageConfigAccount,
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfigaccount/${pageConfigAccount.id}`,
        method: "PATCH",
    }, failureHash),
};
//# sourceMappingURL=pageconfigaccount.js.map